import { MESSAGE_TYPES } from "../../../utils/Enum";

export const IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/jpg",        // Added
  "image/svg+xml",    // Added
  "image/webp",       // Added
  "image/gif"         // Added
];

export const VIDEO_TYPES = [
  "video/mp4",
  "video/3gp",        // Already present
  "video/webm"
];

export const AUDIO_TYPES = [
  "audio/aac",        // Already present
  "audio/mp4",        // Already present
  "audio/mpeg",
  "audio/AMR",        // Already present
  "audio/wav"         // Added
];
export const STICKER_TYPES = ["image/webp"];

export const DOCUMENT_TYPES = [
  "text/csv",
  "text/plain",
  "application/pdf",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/rtf", // ✅ Added for `.rtf`
  "application/vnd.oasis.opendocument.text",       // ✅ Added for `.odt`
  "application/vnd.oasis.opendocument.spreadsheet",// ✅ Added for `.ods`
  "application/vnd.oasis.opendocument.presentation"// ✅ Added for `.odp`
];

export enum ImageState {
  INITIAL = "initial",
  SEARCH = "search",
  GALLERY = "gallery",
  UPLOADED = "uploaded",
}

export const getCorrectMediaFormats = (mediaType: string) => {
  if (mediaType === "video") {
    return VIDEO_TYPES;
  } else if (mediaType === "image") {
    return IMAGE_TYPES;
  } else if (mediaType === "document") {
    return DOCUMENT_TYPES;
  } else if (mediaType === "sticker") {
    return STICKER_TYPES;
  } else if (mediaType === "audio") {
    return AUDIO_TYPES;
  } else {
    return [];
  }
};
export const getUploadedMediaType = (mimeType: string) => {
  if (IMAGE_TYPES?.includes(mimeType)) {
    return "image";
  } else if (VIDEO_TYPES?.includes(mimeType)) {
    return "video";
  } else if (DOCUMENT_TYPES?.includes(mimeType)) {
    return "document";
  } else if (AUDIO_TYPES?.includes(mimeType)) {
    return "audio";
  } else {
    return "document";
  }
};
export const getCorrectMediaSize = (mediaType: string) => {
  if (mediaType === "video") {
    return 16777216;
  } else if (mediaType === "image") {
    return 5242880;
  } else if (mediaType === "document") {
    return 104857600;
  } else if (mediaType === "sticker") {
    return 1048576;
  } else if (mediaType === "audio") {
    return 5242880;
  } else {
    return 1048576;
  }
};

export const getMessageMediaTypeForBot = (type: string) => {
  if (type === "image") {
    return MESSAGE_TYPES.IMAGE;
  } else if (type === "document") {
    return MESSAGE_TYPES.DOCUMENT;
  } else if (type === "video") {
    return MESSAGE_TYPES.VIDEO;
  } else if (type === "audio") {
    return MESSAGE_TYPES.AUDIO;
  } else {
    return MESSAGE_TYPES.FILE;
  }
};

export const sizeInMB = (sizeInBytes: number) => {
  return (sizeInBytes / (1024 * 1024)).toFixed(2);
};

export function removeCharactersFromString(str:string, length:number= 1) {
  return str?.slice(length) ?? str;
}
